import type { IconSvgObject } from './types';

const QwenIcon: IconSvgObject = [
  ["path", { d: "M9 2H12.5L14 4.5H19.13L20.5 7M22 14.5L20.3545 17.163H17.8782L15.0001 22H11.7825M5 20L3.5 17.5L4.5 14.5L2 9.5L4 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M19.1901 9.66219L20.5001 7.0008H9.99995L11 5.0004L8.99995 2.0004L6.74873 7.0008H4.00005L8.99995 17.0004H5.99995L4.99995 20.0004H10.5L11.7516 22.0004L17.4017 12.0659L18.9401 14.5004H22L19.1901 9.66219Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.0001 15.5L9.00006 10H15.0001L12.0001 15.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default QwenIcon;
